import React, { Component } from 'react'
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { MDBDataTableV5, MDBCol, MDBTableBody, MDBTableHead } from 'mdbreact';
import { Link } from 'react-router-dom';

import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import GetApiCall from '../../GETAPI';
import moment from 'moment';
import Parser from "html-react-parser";


import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';



import DateTimePicker from 'react-datetime-picker';

class cutomerList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allDetails: [],
            isdeleted: false,
            searchInput: '',
            Details: '',
            FromDate: null,
            ToDates: null


        };
    }


    componentDidMount() {
        Notiflix.Loading.Init({
            svgColor: 'rgb(171, 61, 0)'


        });


        var login = localStorage.getItem('LoginDetail');
        var details = JSON.parse(login)
        this.setState({
            Details: details[0].fld_usertype,

        })
        
    if (details[0].fld_usertype != "Admin")
    {
      window.location.href = "/"
      }

        // Notiflix.Loading.Dots('');



        GetApiCall.getRequest("Get_MonthlyClientApproved").then(resultdes =>
            resultdes.json().then(obj => {

                this.setState({
                    allDetails: obj.data
                })


                Notiflix.Loading.Remove();
            }))

    }

    viewdetail = (data) => {
        if (this.state.isdeleted === false) {
            return (
                localStorage.setItem('ClientDetails', [JSON.stringify(data)]),

                this.props.history.push('/edit_client')
            )
        }
        else if (this.state.isdeleted === true) {
            return (
                localStorage.setItem('ClientDetails', [JSON.stringify(data)]),
                this.props.history.push('/view-clients')
            )

        }

    }



    SearchData() {
        if (this.state.FromDate !== null || this.state.ToDates !== null) {
            Notiflix.Loading.Dots('Please wait...');

            PostApiCall.postRequest({
                FromDate: moment(this.state.FromDate).format('YYYY-MM-DD') + ' ' + '00:00',
                ToDate: moment(this.state.ToDates).format('YYYY-MM-DD') + ' ' + '00:00',

            }, "Get_MonthlyClientApproved").then((resultcategory =>
                resultcategory.json().then(obj2 => {

                    if (resultcategory.status === 200 || resultcategory.status === 201) {
                        console.log(obj2.data)
                        this.setState({
                            ...this.state,
                            allDetails: obj2.data
                        });


                        Notiflix.Loading.Remove()


                    }
                    else {
                        Notiflix.Loading.Remove();
                        Notiflix.Notify.Failure(obj2.data);
                    }


                }

                )
            ))
        }
        else {
            Notiflix.Notify.Failure('Please select from date and to date');
        }

    }



    // fld_gender
    seachBarHandler = (e) => {
        this.setState({ ...this.state, searchInput: e.target.value })
    }
    render() {

        const data = {
            columns: [
                {
                    label: 'S.No.',
                    field: 'serial',
                    sort: 'disabled',
                    width: 150
                },
                {
                    label: "Name",
                    field: "name",
                    sort: "disabled",
                    width: 150
                },
                {
                    label: "Mobile Number",
                    field: "mobNo",
                    sort: "disabled",
                    width: 100
                },
                {
                    label: "Email",
                    field: "email",
                    sort: "disabled",
                    width: 150
                },
                {
                    label: "Action",
                    field: "action",
                    sort: "disabled",
                    width: 100
                }

            ],
            rows:
                this.state.allDetails.filter(data => {
                    let name = [...data.fld_name.toLowerCase().matchAll(this.state.searchInput.toLowerCase())]
                    let mobno = [...data.fld_mobile.toLocaleLowerCase().matchAll(this.state.searchInput.toLocaleLowerCase())]
                    let email = [...data.fld_email.toLowerCase().matchAll(this.state.searchInput.toLocaleLowerCase())]

                    if (this.state.searchInput.length > 0 && name[0]) {

                        return data
                    }

                    if (this.state.searchInput.length > 0 && mobno[0]) {
                        return data
                    }
                    if (this.state.searchInput.length > 0 && email[0]) {
                        return data
                    }
                    if (this.state.searchInput.length == 0) {
                        return data
                    }

                }).map((data, i) => {
                    //  console.log(data)
                    return {
                        serial: <td>{(i + 1)}</td>,
                        name: <td>{data.fld_name}</td>,
                        mobNo: <td>{data.fld_mobile}</td>,
                        email: <td>{data.fld_email}</td>,
                        action: <td className='text-center actionuser' style={{ display: this.state.Details == 'Admin' ? '' : 'none' }}>
                            <i className="fas fa-edit btn" style={{ fontSize: '15px', marginTop: '-11px' }}
                                onClick={() => this.viewdetail(data)}>


                            </i>
                            {/* <span className='btn' style={{ marginTop: '-9px' }}>
                                <i className="fa fa-trash py-auto " aria-hidden="true" style={{ fontSize: '15px' }}
                                    onClick={() => {
                                        confirmAlert({
                                            title: 'Confirm to Delete',
                                            message: 'Are you sure you want to delete client.',
                                            buttons: [
                                                {
                                                    label: 'Yes',
                                                    onClick: () => {
                                                        Notiflix.Loading.Dots('');

                                                        this.setState({ isdeleted: true })
                                                        Notiflix.Loading.Dots('Please wait...');
                                                        PostApiCall.postRequest({
                                                            id: data.fld_id
                                                        }, "Delete_New_MonthlyClient").then((result) =>

                                                            result.json().then(obj => {
                                                                if (result.status == 200 || result.status == 201) {

                                                                    //  console.log(obj)
                                                                    // Notiflix.Loading.Remove();
                                                                    Notiflix.Notify.Success('Client Deleted Sucessfully.')
                                                                    window.location.reload()
                                                                } else {
                                                                    //   Notiflix.Loading.Remove();
                                                                    Notiflix.Notify.Failure('Something went wrong, try again later.')
                                                                }
                                                            })
                                                        )
                                                    }
                                                },
                                                {
                                                    label: 'No',
                                                    // onClick: () => alert('Click No')
                                                }
                                            ]
                                        });
                                    }} />
                            </span> */}

                        </td>



                    }
                })
        };

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                        {/* Render Breadcrumb */}
                        <Breadcrumbs title={'Manage Clients'} breadcrumbItem={'View Clients'} />
                        <Row>
                            <Col xl="12">

                                <Card className="overflow-hidden">
                                    <div className="maxXchange-bg-soft-pink" style={{ background: 'rgb(171, 61, 0)' }}>
                                        <Row>


                                            <Col xs="6">
                                                <div className="maxXchange-text p-3">
                                                    <h5 className="maxXchange-text text-white" >Manage Clients</h5>

                                                </div>
                                            </Col>


                                        </Row>
                                        <Row>

                                        </Row>
                                    </div>
                                    <Card className="overflow-hidden">
                                        <Row>
                                            <Col xl="12">


                                                <Card className="overflow-hidden">
                                                    <div className="maxXchange-bg-soft-pink" style={{ background: '#dfb65c' }}>
                                                        <Row>


                                                            <Col xs="6">
                                                                <div className="maxXchange-text p-3">
                                                                    <h5 className="maxXchange-text">View Clients</h5>

                                                                </div>
                                                            </Col>


                                                        </Row>
                                                    </div>
                                                    {/* <Card>
                                                        <CardBody>
                                                            <div className="row my-1">

                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label>From Date</label>
                                                                        <input className="form-control"
                                                                            type="date" value={this.state.FromDate} placeholder='Select From Date'
                                                                            onChange={(time) => {
                                                                                this.setState({
                                                                                    FromDate: time.target.value
                                                                                })
                                                                                
                                                                            }} />
                                                                    </div>
                                                                </div>

                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label>To Date</label>
                                                                        <input className="form-control"
                                                                            type="date" value={this.state.ToDates}
                                                                            placeholder='select to date'
                                                                            onChange={(time) => {
                                                                                this.setState({
                                                                                    ToDates: time.target.value
                                                                                })
                                                                            }} />
                                                                    </div>
                                                                </div>






                                                                <div className="col-2">
                                                                    <div className="position-relative">
                                                                        <a onClick={this.SearchData.bind(this)}
                                                                            className={'btn'}
                                                                            style={{ backgroundColor: '#880105', color: '#e1b761', marginTop: '13%' }}>
                                                                            Search <i className="fa fa-search" aria-hidden="true"></i>
                                                                        </a>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                        </CardBody>{" "}

                                                    </Card> */}
                                                    <CardBody className="pt-0">
                                                        <Row>
                                                            <MDBCol md="6" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                                                <input className="form-control" type="text" placeholder="Search" aria-label="Search" onChange={(e) => this.seachBarHandler(e)} value={this.state.searchInput} />
                                                            </MDBCol>
                                                            <Col md="12">

                                                                <MDBDataTableV5

                                                                    striped
                                                                    bordered
                                                                    small
                                                                    data={data}
                                                                    searchBottom={false}
                                                                    seachTop={true}
                                                                >

                                                                    <MDBTableHead columns={data.columns} />
                                                                    <MDBTableBody rows={data.rows} />
                                                                </MDBDataTableV5>

                                                            </Col>

                                                        </Row>
                                                    </CardBody>
                                                </Card>


                                                {/* <WelcomeComp /> */}

                                            </Col>
                                        </Row>
                                    </Card>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
export default cutomerList